import {useEffect, Fragment} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {readEndpoint} from 'redux-json-api'

import {currentUserConfig} from '../lib/userTools'
import {findRawResourceByAttributeId, findRawResourceById} from '../lib/plan_data/userData'
import routerUtils from '../lib/routerUtils'
import {webAppsUrl} from '../lib/urlTools'
import Loader from './NewLoader'


export const PendingRequiredFirmUserActionCheck = props => {
  const {userConfig, organizationConfig, firm} = props
  const isQuarterback = userConfig.get('quarterback')
  const isFirmUser = userConfig.get('firm-id') && !userConfig.get('client')
  const isFuneralHome = firm.get('firm-type') === 'funeral_home'

  const needsTfaSetup = !userConfig.get('tfa-enabled') && (
    organizationConfig.get('mandatory-tfa-enabled') ||
    isQuarterback ||
    (isFirmUser && isFuneralHome)
  )

  useEffect(() => {
    if (userConfig.get('firm-id') && !userConfig.get('client') && firm.isEmpty()) {
      props.readEndpoint(`firms/${userConfig.get('firm-id')}?include=client-seats,cobranding,firm-config,disclosure,firm-seats,organization.organization-config`)
      props.readEndpoint(`users/${userConfig.get('id')}?include=firm-user-config`)
    }
  }, [userConfig.get('firm-id'), userConfig.get('client'), firm.isEmpty()])

  useEffect(() => {
    if (needsTfaSetup)
      routerUtils.setLocation(webAppsUrl('auth/tfa-intro'))
  }, [needsTfaSetup])

  if (needsTfaSetup)
    return <Loader loading={true} />

  return (
    <Fragment>
      {props.children}
    </Fragment>
  )
}

PendingRequiredFirmUserActionCheck.propTypes = {
  userConfig: PropTypes.instanceOf(Map),
  organizationConfig: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map),
  readEndpoint: PropTypes.func
}

PendingRequiredFirmUserActionCheck.defaultProps = {
  organizationConfig: Map(),
  firm: Map(),
  userConfig: Map()
}

const mapStateToProps = state => {
  const userConfig = currentUserConfig(state.api)

  const firm = findRawResourceById({
    rawResource: state.api.firms,
    id: userConfig.get('firm-id')
  })

  const organizationConfig = findRawResourceByAttributeId({
    rawResource: state.api['organization-configs'],
    attribute: 'organization-id',
    id: firm.get('organization-id')
  })

  return {userConfig, organizationConfig, firm}
}

export default connect(mapStateToProps, {readEndpoint})(PendingRequiredFirmUserActionCheck)
